import { render } from "./ResultsView.vue?vue&type=template&id=e1550944&scoped=true"
import script from "./ResultsView.vue?vue&type=script&lang=js"
export * from "./ResultsView.vue?vue&type=script&lang=js"

import "./ResultsView.vue?vue&type=style&index=0&id=e1550944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1550944"]])

export default __exports__